import s from './ConnectorSubtitle.module.scss';
import { Subtitle } from '@tremor/react';
import { ComponentProps, FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren, ComponentProps<typeof Subtitle> {}

export const ConnectorSubtitle: FC<Props> = ({ children, ...rest }) => (
  <Subtitle className={s.subtitle} {...rest}>
    {children}
  </Subtitle>
);
